import { getNblyApiHeaders } from "../api";
import { apiConfig } from "../config";
import { store_data } from "../util";

export function getFullAttribute(webLocationId:any, serviceHandler:any){
    $.ajax({
        url: apiConfig.fullAttribute+"?franchiseWeblocationId=" + webLocationId + "&apikey=" + window.DEFINE_VALUE.JS_API_KEY+"&"+getNblyApiHeaders(),
        type: "GET",
        success: function (data){
            let phoneNumber = data.mainPhoneNumber;
            window.objOSGlobal.requestBodyValues.IsLeadOnly = data.onlineScheduling ? false : true;
            if(phoneNumber){
                // if(!(/^(\([0-9]{3}\)(\s)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$/.test(phoneNumber))){
                //     phoneNumber = phoneNumber.toString().match(/(\d{3})(\d{3})(\d{4})/);
                //     phoneNumber = "(" + phoneNumber[1] + ") " + phoneNumber[2] + "-" + phoneNumber[3];
                //     }
                    $('.result-contact').attr('href', 'tel:' + phoneNumber);
                    $('.result-contact .results-phone-num').text(phoneNumber);
                    window.objOSGlobal.paramsUI.brandPhoneNumber = phoneNumber;
                    store_data(phoneNumber, 'brandPhoneNumber');
                    $('#modal-header-contact').removeClass("hidden");
                }
                else{  
                    $('#modal-header-contact').addClass("hidden");
                }

                serviceHandler(data);
        }
    });
}
